import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Logo from "../Components/Layout/Logo";

//Material Ui Stuffs
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@material-ui/core";

// Redux Stuff
import { connect } from "react-redux";
import { loginUser } from "../redux/actions/userActions";

// Hooks Stuff
import { usePrevious } from "../util/customHooks";

const styles = {
  root: {
    textAlign: "center",
    padding:"1rem"
  },

  pageTitle: {
    margin: "5px auto 10px auto",
    fontWeight: "bold",
  },

  textField: {
    margin: "10px auto 10px auto",
    width: "90%",
  },

  button: {
    marginTop: 20,
    marginBottom: 10,
    position: "relative",
    width: "90%",
    color: "#fff !important",
  },

  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },

  progress: {
    position: "absolute",
  },

  mainForm: {
    width: "auto",
  },
};

const Login = (props) => {
  const {
    classes,
    history,
    loginUser,
    UI: { loading },
  } = props;

  //Hooks
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setError] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const userData = {
      email,
      password,
    };
    loginUser(userData, history);
  };

  const previousError = usePrevious(errors);
  const newErrors = props.UI.errors;

  useEffect(() => {
    if (previousError !== newErrors) {
      setError(newErrors);
    }
  }, [previousError, newErrors]);

  return (
    <Grid container className={classes.root} justify="center" alignContent="center">
      <Grid item sm={4}>
        <Logo />
        <Typography variant="h4" className={classes.pageTitle}>
          Login to StudyBud
        </Typography>
        <form className={classes.mainForm} noValidate onSubmit={handleSubmit}>
          <TextField
            id="email"
            name="email"
            type="email"
            label="Email"
            className={classes.textField}
            helperText={errors.email}
            error={errors.email ? true : false}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            variant="outlined"
          />
          <TextField
            id="outlined-password-input"
            name="password"
            label="Password"
            type="password"
            className={classes.textField}
            helperText={errors.password}
            error={errors.password ? true : false}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            variant="outlined"
          />
          {errors.general && (
            <Typography variant="body2" className={classes.customError}>
              {errors.general}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            disabled={loading}
            size="large"
          >
            Log in
            {loading && (
              <CircularProgress size={30} className={classes.progress} />
            )}
          </Button>
          <br />
          <small>
            Don't have an account? Sign up{" "}
            <Link style={{ color: "#2942ce" }} to="/signup">
              here
            </Link>
          </small>
        </form>
      </Grid>
    </Grid>
  );
};

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  loginUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

const mapActionsToProps = {
  loginUser,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(Login));
